import { Component } from '@angular/core';
import { LocalStorageService } from '@services/local-storage-service';
import { BroadcastService } from '@services/broadcast-service';
import { EventLoggerService } from '@services/event-logger-service';
import { CommonUtilityHelper } from '@services/common-utility-helper/common-utility-helper';
import { Router } from '@angular/router';
import { AppConfig } from '../../app.config';

@Component({
  selector: 'acquisition-user-query',
  templateUrl: 're-acquisition-user-query.html',
  standalone: false,
})

export class ReAcquisitionUserQueryComponent {
  private readonly MIN_QUERY_LENGTH = 9;
  private readonly ERROR_MESSAGES = {
    EMPTY_RESPONSE: "This field is required — let the doctor know your concern.",
    MIN_LENGTH: "Your message must be at least 10 characters to help the doctor understand your concern."
  };

  userQuery: string;
  selectedConcern: 'hair' | 'face' = 'face';
  invalidUserInputError: string = '';
  constructor(
    private readonly localStorageService: LocalStorageService,
    private readonly broadcast: BroadcastService,
    private readonly eventLogger: EventLoggerService,
    public appConfig: AppConfig,
    private readonly router: Router,
    public readonly commonUtilityHelper: CommonUtilityHelper) {
  }

  ngOnInit(): void {
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 're-acquisition-user-query' }));
  }

  back(): void {
    this.broadcast.broadcast('NAVIGATION_BACK');
  }

  async submit(): Promise<void> {
    if (this.isUserQueryInvalid()) return;
    try {
      this.localStorageService.setValue('userQuery', this.userQuery);
      this.router.navigate(['/re-acquisition/take-photo'], { queryParams: { selectedConcern: this.selectedConcern } });
    } catch (error) {
      this.broadcast.broadcast('NOTIFY', { message: error.toString() });
    }
  }

  isUserQueryInvalid(): boolean {
    if (!this.userQuery?.length) {
      this.invalidUserInputError = this.ERROR_MESSAGES.EMPTY_RESPONSE;
      return true;
    }

    if (this.userQuery.length <= this.MIN_QUERY_LENGTH) {
      this.invalidUserInputError = this.ERROR_MESSAGES.MIN_LENGTH;
      return true;
    }

    this.invalidUserInputError = ""; // ✅ Clear error if input is valid
    return false;
  }

  handleOnChange(): void {
    if (this.userQuery.length > this.MIN_QUERY_LENGTH || !this.userQuery.length) {
      this.invalidUserInputError = "";
    }
  }

  skip(): void {
    this.router.navigate(['/user'], { queryParams: { tab: 'home' } });
  }
  changeConcern(selectedConcern: 'face' | 'hair'): void {
    this.selectedConcern = selectedConcern;
    if (!this.userQuery?.length) {
      this.invalidUserInputError = "";
    }
  }
}
